<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'ModuleAccountChangePassword',
  computed: {
    ...mapState('administrator/me', [
      'item',
      'currentPassword',
    ]),
    localCurrentPassword: {
      get() {
        return this.currentPassword;
      },
      set(value) {
        this.setCurrentPassword(value);
      },
    },
    password: {
      get() {
        return this.item.password;
      },
      set(value) {
        this.setPassword(value);
      },
    },
  },
  methods: {
    ...mapActions('administrator/me', [
      'save',
      'logout',
    ]),
    ...mapMutations('administrator/me', [
      'setCurrentPassword',
      'setPassword',
    ]),
    localSave () {
      const payload = {
        plainPassword: this.item.password,
      };

      this.save(payload)
        .then(res => {
          if (res) {
            this.logout();
          }
        })
      ;
    },
  },
};
</script>
<template>
  <div class="box-padding mt-2">
    <h2>Change Password</h2>
    <div class="form-group mt-3">
      <label for="new_password" class="d-block">New Password</label>
      <input id="new_password" class="form-control rounded-0" v-model="password" />
    </div>
    <div class="form-group mt-5">
      <label for="current_password" class="d-block">Current Password</label>
      <input id="current_password" class="form-control rounded-0" v-model="localCurrentPassword" />
    </div>
    <div class="form-group mt-3 text-right">
      <button class="btn btn-primary" @click="localSave">Save</button>
    </div>
  </div>
</template>
